/* ==========================================================================
   KIMIYA — comportamiento propio
   Un init por componente. Cada uno sale sin hacer nada si su elemento no
   existe, asi el mismo archivo sirve en todas las paginas.
   ========================================================================== */

(function () {
  'use strict';

  var sinMovimiento =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Animaciones de entrada ------------------------------------------ */

  function initReveal() {
    var elementos = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!elementos.length) return;

    if (sinMovimiento || !('IntersectionObserver' in window)) {
      for (var i = 0; i < elementos.length; i++) elementos[i].classList.add('mt-visible');
      return;
    }

    var alguienAparecio = false;

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (entrada.isIntersecting) {
            alguienAparecio = true;
            entrada.target.classList.add('mt-visible');
            observador.unobserve(entrada.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    for (var j = 0; j < elementos.length; j++) observador.observe(elementos[j]);

    // Red de seguridad: si a los 3 segundos el observador no ha mostrado nada
    // (navegador raro, pestaña en segundo plano, extensión que interfiere),
    // enseñamos todo el contenido. Mejor sin animación que invisible.
    setTimeout(function () {
      if (alguienAparecio) return;
      observador.disconnect();
      document.querySelectorAll('.mt-reveal').forEach(function (el) {
        el.classList.add('mt-visible');
      });
    }, 3000);
  }

  /* --- Preguntas frecuentes -------------------------------------------- */

  function initFaq() {
    var items = document.querySelectorAll('.mt-faq__item');
    if (!items.length) return;

    items.forEach(function (item) {
      var boton = item.querySelector('.mt-faq__btn');
      var panel = item.querySelector('.mt-faq__panel');
      if (!boton || !panel || boton.dataset.mtListo === '1') return;
      boton.dataset.mtListo = '1';

      boton.addEventListener('click', function () {
        var abierto = item.classList.contains('mt-abierto');
        var grupo = item.closest('.mt-faq__grid');

        if (grupo) {
          grupo.querySelectorAll('.mt-faq__item.mt-abierto').forEach(function (otro) {
            if (otro === item) return;
            otro.classList.remove('mt-abierto');
            var otroPanel = otro.querySelector('.mt-faq__panel');
            var otroBoton = otro.querySelector('.mt-faq__btn');
            if (otroPanel) otroPanel.style.maxHeight = '0px';
            if (otroBoton) otroBoton.setAttribute('aria-expanded', 'false');
          });
        }

        if (abierto) {
          item.classList.remove('mt-abierto');
          panel.style.maxHeight = '0px';
          boton.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('mt-abierto');
          panel.style.maxHeight = panel.scrollHeight + 'px';
          boton.setAttribute('aria-expanded', 'true');
        }
      });
    });

    window.addEventListener('resize', function () {
      document.querySelectorAll('.mt-faq__item.mt-abierto .mt-faq__panel').forEach(function (p) {
        p.style.maxHeight = p.scrollHeight + 'px';
      });
    });
  }

  /* --- Galeria del producto -------------------------------------------- */

  function initGaleria() {
    var galerias = document.querySelectorAll('[data-mt-galeria]');
    if (!galerias.length) return;

    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector('[data-mt-galeria-principal]');
      var minis = galeria.querySelectorAll('[data-mt-mini]');
      if (!principal || !minis.length) return;

      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-mt-src');
          var alt = mini.getAttribute('data-mt-alt') || '';
          if (!src) return;
          principal.setAttribute('src', src);
          principal.setAttribute('alt', alt);
          galeria.querySelectorAll('[data-mt-mini].mt-activa').forEach(function (a) {
            a.classList.remove('mt-activa');
          });
          mini.classList.add('mt-activa');
        });
      });
    });
  }

  /* --- Selector de variantes ------------------------------------------- */

  function initVariantes() {
    var bloques = document.querySelectorAll('[data-mt-variantes]');
    if (!bloques.length) return;

    bloques.forEach(function (bloque) {
      var datos = bloque.querySelector('[data-mt-variantes-json]');
      if (!datos) return;

      var variantes;
      try {
        variantes = JSON.parse(datos.textContent);
      } catch (e) {
        return;
      }
      if (!variantes || !variantes.length) return;

      var botones = bloque.querySelectorAll('[data-mt-opcion]');
      var campoId = bloque.querySelector('[data-mt-variante-id]');
      var precioAhora = bloque.querySelector('[data-mt-precio-ahora]');
      var precioAntes = bloque.querySelector('[data-mt-precio-antes]');
      var botonComprar = bloque.querySelector('[data-mt-comprar]');
      var textoComprar = botonComprar ? botonComprar.getAttribute('data-mt-texto') : '';
      var textoAgotado = botonComprar ? botonComprar.getAttribute('data-mt-agotado') : '';

      function seleccionActual() {
        var elegidas = [];
        bloque.querySelectorAll('[data-mt-grupo-opcion]').forEach(function (grupo) {
          var activa = grupo.querySelector('[data-mt-opcion].mt-activa');
          elegidas.push(activa ? activa.getAttribute('data-mt-valor') : null);
        });
        return elegidas;
      }

      function formatearDinero(centavos) {
        var plantilla = bloque.getAttribute('data-mt-formato-dinero') || '${{amount}}';
        // ¿La tienda separa los miles con punto y los decimales con coma?
        var estiloEuropeo = plantilla.indexOf('comma_separator') !== -1;
        var sepMiles = estiloEuropeo ? '.' : ',';
        var sepDecimal = estiloEuropeo ? ',' : '.';

        var valor = (centavos / 100).toFixed(2);
        var partes = valor.split('.');
        var entero = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, sepMiles);

        // Igual que el filtro money_without_trailing_zeros de Shopify:
        // si no hay céntimos, no se muestran.
        var texto = partes[1] === '00' ? entero : entero + sepDecimal + partes[1];

        return plantilla.replace(/\{\{\s*[a-z_]*amount[a-z_]*\s*\}\}/, texto);
      }

      function actualizar() {
        var elegidas = seleccionActual();
        var encontrada = null;

        for (var i = 0; i < variantes.length; i++) {
          var v = variantes[i];
          var coincide = true;
          for (var k = 0; k < elegidas.length; k++) {
            if (elegidas[k] !== null && v.options[k] !== elegidas[k]) {
              coincide = false;
              break;
            }
          }
          if (coincide) {
            encontrada = v;
            break;
          }
        }

        if (!encontrada) return;

        if (campoId) campoId.value = encontrada.id;

        // Los formularios de las apps de pago contra entrega (Releasit y
        // similares) traen su propio campo oculto con la variante y no se
        // enteran de nuestro selector. Se lo sincronizamos a mano: sin esto,
        // quien elija el combo acabaría pagando el precio de una unidad.
        document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (campo) {
          if (campo.value === String(encontrada.id)) return;
          campo.value = encontrada.id;
          campo.dispatchEvent(new Event('input', { bubbles: true }));
          campo.dispatchEvent(new Event('change', { bubbles: true }));
        });

        if (precioAhora) precioAhora.textContent = formatearDinero(encontrada.price);

        if (precioAntes) {
          if (encontrada.compare_at_price && encontrada.compare_at_price > encontrada.price) {
            precioAntes.textContent = formatearDinero(encontrada.compare_at_price);
            precioAntes.style.display = '';
          } else {
            precioAntes.style.display = 'none';
          }
        }

        if (botonComprar) {
          if (encontrada.available) {
            botonComprar.removeAttribute('disabled');
            botonComprar.classList.remove('mt-btn--agotado');
            if (textoComprar) botonComprar.textContent = textoComprar;
          } else {
            botonComprar.setAttribute('disabled', 'disabled');
            botonComprar.classList.add('mt-btn--agotado');
            if (textoAgotado) botonComprar.textContent = textoAgotado;
          }
        }

        var barraPrecio = document.querySelector('[data-mt-barra-precio]');
        if (barraPrecio) barraPrecio.textContent = formatearDinero(encontrada.price);

        var barraAntes = document.querySelector('[data-mt-barra-antes]');
        if (barraAntes) {
          if (encontrada.compare_at_price && encontrada.compare_at_price > encontrada.price) {
            barraAntes.textContent = formatearDinero(encontrada.compare_at_price);
            barraAntes.style.display = '';
          } else {
            barraAntes.style.display = 'none';
          }
        }
      }

      botones.forEach(function (boton) {
        boton.addEventListener('click', function () {
          var grupo = boton.closest('[data-mt-grupo-opcion]');
          if (grupo) {
            grupo.querySelectorAll('[data-mt-opcion].mt-activa').forEach(function (a) {
              a.classList.remove('mt-activa');
            });
          }
          boton.classList.add('mt-activa');
          actualizar();
        });
      });

      // Seguro adicional: las apps de pago contra entrega montan su bloque
      // por su cuenta y pueden volver a dibujarlo después de nosotros.
      // Antes de que llegue el clic a su botón, resincronizamos la variante.
      if (!bloque.dataset.mtSeguroClic) {
        bloque.dataset.mtSeguroClic = '1';
        document.addEventListener(
          'click',
          function (evento) {
            var destino = evento.target;
            if (!destino || !destino.closest) return;
            if (!destino.closest('form[action="/cart/add"], [class*="_rsi-"], [class*="releasit"]')) return;
            actualizar();
          },
          true
        );
      }

      // Y una primera pasada al cargar, por si la app monta su formulario
      // más tarde que nosotros.
      setTimeout(actualizar, 1200);
      setTimeout(actualizar, 3000);
    });
  }

  /* --- Barra fija de compra en movil ------------------------------------ */

  function initBarra() {
    var barra = document.querySelector('[data-mt-barra]');
    if (!barra) return;

    var disparador = document.querySelector('[data-mt-barra-disparador]');

    function evaluar() {
      var mostrar;
      if (disparador) {
        mostrar = disparador.getBoundingClientRect().bottom < 0;
      } else {
        mostrar = window.scrollY > 500;
      }
      barra.classList.toggle('mt-visible', mostrar);
    }

    evaluar();
    window.addEventListener('scroll', evaluar, { passive: true });
    window.addEventListener('resize', evaluar, { passive: true });
  }

  /* --- Cifras en círculo (% de beneficio) -------------------------------- */

  function initCifras() {
    var aros = document.querySelectorAll('[data-mt-pct]:not([data-mt-listo])');
    if (!aros.length) return;

    var PERIMETRO = 2 * Math.PI * 52; // el radio del círculo del SVG es 52

    function pintar(aro) {
      var objetivo = parseInt(aro.getAttribute('data-mt-pct'), 10) || 0;
      var barra = aro.querySelector('[data-mt-pct-barra]');
      var cifra = aro.querySelector('[data-mt-pct-cifra]');

      if (barra) {
        barra.style.strokeDashoffset = PERIMETRO - (PERIMETRO * objetivo) / 100;
      }

      if (!cifra) return;

      if (sinMovimiento || objetivo === 0) {
        cifra.textContent = objetivo;
        return;
      }

      var inicio = null;
      var duracion = 1400;
      var terminado = false;

      function paso(ahora) {
        if (inicio === null) inicio = ahora;
        var avance = Math.min((ahora - inicio) / duracion, 1);
        // suavizado: rápido al principio, lento al final
        var suave = 1 - Math.pow(1 - avance, 3);
        cifra.textContent = Math.round(objetivo * suave);
        if (avance < 1) {
          requestAnimationFrame(paso);
        } else {
          terminado = true;
        }
      }

      requestAnimationFrame(paso);

      // Si la pestaña estaba en segundo plano, requestAnimationFrame no corre
      // y la cifra se quedaría en cero. Nos aseguramos de dejar el número final.
      setTimeout(function () {
        if (!terminado) cifra.textContent = objetivo;
      }, duracion + 600);
    }

    if (sinMovimiento || !('IntersectionObserver' in window)) {
      aros.forEach(function (aro) {
        aro.setAttribute('data-mt-listo', '1');
        pintar(aro);
      });
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          entrada.target.setAttribute('data-mt-listo', '1');
          pintar(entrada.target);
          observador.unobserve(entrada.target);
        });
      },
      { threshold: 0.35 }
    );

    aros.forEach(function (aro) {
      observador.observe(aro);
    });

    // Misma red de seguridad que en los reveals.
    setTimeout(function () {
      document.querySelectorAll('[data-mt-pct]:not([data-mt-listo])').forEach(function (aro) {
        aro.setAttribute('data-mt-listo', '1');
        pintar(aro);
      });
    }, 3000);
  }

  /* --- Enlaces internos --------------------------------------------------- */

  function irA(selector, evento) {
    var destino = document.querySelector(selector);
    if (!destino) return;
    evento.preventDefault();
    destino.scrollIntoView({
      behavior: sinMovimiento ? 'auto' : 'smooth',
      block: 'start'
    });
  }

  function initAnclas() {
    document.querySelectorAll('[data-mt-ir-a-compra]').forEach(function (enlace) {
      if (enlace.dataset.mtAncla === '1') return;
      enlace.dataset.mtAncla = '1';
      enlace.addEventListener('click', function (evento) {
        irA('#mt-comprar', evento);
      });
    });

    document.querySelectorAll('[data-mt-ir-a-resenas]').forEach(function (enlace) {
      if (enlace.dataset.mtAncla === '1') return;
      enlace.dataset.mtAncla = '1';
      enlace.addEventListener('click', function (evento) {
        irA('#resenas', evento);
      });
    });
  }

  /* --- Salvavidas del botón de contra entrega ---------------------------- */

  /*
   * La app de contra entrega (Releasit) monta su botón sobre nuestro enlace a
   * /rsi-btn-hook: lo borra y pone el suyo en el elemento padre.
   *
   * Si por lo que sea no lo hace —app desinstalada, su CDN caído, un
   * bloqueador de anuncios, o su detección de página falla— nuestro enlace se
   * queda apuntando a /rsi-btn-hook, que es una URL que no existe. Eso sería
   * peor que no tener botón: el cliente decidido acaba en un 404.
   *
   * Así que le damos tiempo a la app y, si no aparece su botón, convertimos el
   * enlace en el de WhatsApp. El pedido se salva por otra vía.
   */
  function initCodRespaldo() {
    var ranura = document.querySelector('[data-mt-cod]');
    if (!ranura || ranura.dataset.mtCodListo === '1') return;
    ranura.dataset.mtCodListo = '1';

    var hueco = ranura.querySelector('[data-mt-cod-hueco]');
    var urlRespaldo = ranura.getAttribute('data-mt-cod-respaldo');
    if (!hueco || !urlRespaldo) return;

    function appHaMontado() {
      // Su botón, ya visible y con tamaño real, dentro de nuestro hueco.
      var suyo = hueco.querySelector('#rsi_buy_now_button, [id^="rsi_buy_now"], ._rsi-buy-now-button');
      if (suyo && suyo.getBoundingClientRect().height > 4) return true;
      // O bien nuestro enlace ya no está: la app se lo llevó por delante.
      return !hueco.querySelector('[data-mt-cod-disparador]');
    }

    function pasarARespaldo() {
      var enlace = hueco.querySelector('[data-mt-cod-disparador]');
      if (!enlace) return;
      var texto = ranura.getAttribute('data-mt-cod-respaldo-texto');
      enlace.setAttribute('href', urlRespaldo);
      enlace.setAttribute('target', '_blank');
      enlace.setAttribute('rel', 'noopener');
      if (texto) enlace.textContent = texto;
      enlace.removeAttribute('data-mt-cod-disparador');
    }

    function revisar(intentosRestantes) {
      if (appHaMontado()) return;
      if (intentosRestantes <= 0) {
        pasarARespaldo();
        return;
      }
      setTimeout(function () {
        revisar(intentosRestantes - 1);
      }, 900);
    }

    // ~7 s de margen: de sobra para la app, poco para el cliente.
    revisar(8);
  }

  /* --- Arranque --------------------------------------------------------- */

  function arrancar() {
    initReveal();
    initFaq();
    initGaleria();
    initVariantes();
    initBarra();
    initCifras();
    initAnclas();
    initCodRespaldo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // El editor visual de Shopify recarga secciones sueltas: re-inicializamos.
  document.addEventListener('shopify:section:load', arrancar);
  document.addEventListener('shopify:section:select', arrancar);
})();
